export default __webpack_public_path__ + "static/media/ai.947db3a4.png";